module.exports = __webpack_public_path__ + "img/box-zohoAlta.406c2f92.png";